import React, {useState, useRef} from "react";
import IconButton from "../common/IconButton";
import NavigationMenu from "./NavigationMenu";
import {OpenInNew} from "@mui/icons-material";

const MenuButton = props => {
    const {id, shortcut, selected, className, disabled = false, handleClick, handleDrawerClick, handleClose, visible = false, highlight = false, iconComponent, menuComponent, iconComponents, menuComponents, menuWidget = false, tabIndex = 0, panelId, ...other} = props;
    const [badgeCount, setBadgeCount] = useState(0);
    const buttonRef = useRef();
    let iconButtonProps = {};
    if (menuComponent) {
        iconButtonProps['aria-expanded'] = visible;
    }

    const handleOpen = () => {
        handleClick(shortcut);
    }

    if (shortcut.shortcutLocation === 'DRAWER') {
        return (
            <div className={'ch-nav-icon-btn'}>
                <IconButton
                    id={id}
                    aria-controls={panelId}
                    className={'ch-icon-btn-on-global ch-nav-item' + (className ? ' ' + className : '')}
                    tooltip={shortcut.name}
                    tabIndex={tabIndex}
                    disabled={disabled}
                    onClick={handleDrawerClick}
                    size="large"
                    ref={buttonRef}
                    {...iconButtonProps}
                    {...other}
                >
                    {iconComponent != undefined && (
                        React.createElement(iconComponent)
                    )}
                    {badgeCount > 0 &&
                        <div className={'ch-badge'}><span>{badgeCount}</span></div>
                    }
                </IconButton>
            </div>
        );
    }

    return (
        <div className={'ch-nav-icon-btn'}>
            <IconButton
                id={id}
                aria-controls={panelId}
                className={'ch-icon-btn-on-global' + (selected ? ' ignore-react-onclickoutside' : '') + ' ch-nav-item' + (className ? ' ' + className : '')}
                tooltip={( shortcut.showExternalIcon ? <div className={'flex smallGap flexAlignCentre'}><span>{shortcut.name}</span><OpenInNew fontSize={'inherit'} /></div> : `${shortcut.name}${badgeCount > 0 ? ` ${badgeCount} item${badgeCount > 1 ? `s` : ``}` : ``}`) }
                tabIndex={tabIndex}
                disabled={disabled}
                onClick={handleOpen}
                size="large"
                ref={buttonRef}
                badge={highlight}
                {...iconButtonProps}
                {...other}
            >
                {iconComponent != undefined && (
                    React.createElement(iconComponent)
                )}

                {badgeCount > 0 &&
                    <div className={'ch-badge'}><span>{badgeCount}</span></div>
                }
            </IconButton>
            {menuComponent !== undefined && (
                <NavigationMenu visible={visible} callback={handleClose} parent={buttonRef.current} menuWidget={menuWidget}>
                    {
                        React.createElement(menuComponent, {
                            ariaLabelledby: id,
                            shortcut: shortcut,
                            fromLogin: false,
                            updateBadgeCount: setBadgeCount,
                            handleClick: handleClick,
                            handleDrawerClick: handleDrawerClick,
                            setBadgeCount: setBadgeCount,
                            iconComponent: iconComponent,
                            iconComponents: iconComponents,
                            menuComponents: menuComponents,
                            handleClose: handleClose
                        })
                    }
                </NavigationMenu>
            )}
        </div>
    );
};

export default MenuButton;